module.exports = __webpack_public_path__ + "static/img/img_icon.f4138e9e.png";